<template>


<div>

<v-row>     
    <v-col>
        <TextField
            :item="{ name: 'Classe', value: 'class', defaultprops:{ show: true }}"
            :valField="displays.params.class"
            :keyup="changeParams"
            />
    </v-col>
    <v-col>
        <v-menu offset-y :close-on-content-click="false">
            <template #activator="{ on, attrs }">
                <v-text-field
                    :value="displays.params.bgcolor || 'Thème métier'"
                    label="Couleur de fond"
                    dense
                    outlined
                    readonly
                    clearable
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    @click:clear.stop="clearBackgroundColor"
                >
                    <template #prepend-inner>
                        <span
                            class="tabs-admin__swatch"
                            :class="{ 'tabs-admin__swatch--theme': !displays.params.bgcolor }"
                            :style="displays.params.bgcolor ? { backgroundColor: displays.params.bgcolor } : {}"
                        />
                    </template>
                </v-text-field>
            </template>
            <v-color-picker
                :value="displays.params.bgcolor || '#FFFFFF'"
                mode="hexa"
                hide-mode-switch
                @input="setBackgroundColor"
            />
        </v-menu>
    </v-col>
    <v-col>
            <SwitchC
            :item="{ name: 'dark mode', value: 'dark' , defaultprops:{ show: true }}"
            :valField="displays.params.dark"
            :change="changeParams"
            />
    </v-col>
    </v-row>
    <v-row>
    <v-col>
            <SwitchC
            :item="{ name: 'position center', value: 'centered', defaultprops:{ show: true }}"
            :valField="displays.params.centered"
            :change="changeParams"
            />
    </v-col>
    <v-col>
            <SwitchC
            :item="{ name: 'position droite', value: 'right', defaultprops:{ show: true }}"
            :valField="displays.params.right"
            :change="changeParams"
            />
    </v-col>
    <v-col>
            <SwitchC
            :item="{ name: 'tabs vertical ?', value: 'vertical', defaultprops:{ show: true }}"
            :valField="displays.params.vertical"
            :change="changeParams"
            />
    </v-col>
    <v-col>
            <SwitchC
            :item="{ name: 'laiser place à une icone dans les tabs ?', value: 'iconText', defaultprops:{ show: true }}"
            :valField="displays.params.iconText"
            :change="changeParams"
            />
    </v-col>
</v-row>

          <v-btn
            fab
            small
            :disabled="!module.id"
            @click="createTab">
            <v-icon>mdi-database-plus-outline</v-icon>
          </v-btn>        

              <SimpleTable
                :Headers="[
                  { text: 'Intitulé', value: 'name' },
                  { text: 'Ordre', value: 'order' }
                ]"
                :isDraggable="true"
                @recepVal="changeOrder"
                :datas="listTabs"
                :editTable="[{ icon: 'mdi-pencil', action: editTabs },{ icon: 'mdi-close', action: eraseTabs }]"
                :del="false"
              />

</div>


</template>



<script>
import { admin } from '../mixins'; 
import { openTabulationEditor } from './navigation'
    export default {
        name : 'TabsModule',
         mixins : [admin],
        props: ["module", "page","modalKey"],

        data: function() {
            return { 
                displays: this.module.displays,
                dialog : null,
                listTabs : [],
            }
        },

        methods : {

            setBackgroundColor(value) {
                this.changeParams({ value: 'bgcolor' }, String(value || '').substring(0, 7).toUpperCase())
            },

            clearBackgroundColor() {
                this.changeParams({ value: 'bgcolor' }, '')
            },

            changeParams(item,value) {
                this.displays.params[item.value] = value
                this.$emit('recepVal',this.displays)
            },

            getTabsFromAPI() {
                this.API({type:'get', url:"/engine/module/tabs/" + this.module.id}).then((resp) => {
                this.listTabs = resp.data
            });
            },

            editTabs(tabs) {
                openTabulationEditor({
                    moduleId: this.module.id,
                    tabulationId: tabs.id,
                    onSaved: () => this.getTabsFromAPI(),
                })
            },

            createTab() {
                openTabulationEditor({
                    moduleId: this.module.id,
                    tabulationId: 'new',
                    onSaved: () => this.getTabsFromAPI(),
                })
            },

            eraseTabs(tabs) {
                if(confirm('Etes vous sur ??')) {
                    this.API({type:'post', url:"/engine/module/"+this.module.id+"/tabulation/modify", params :{tab:tabs,type:'erase'}}).then((resp) => {
                        if(resp.data.success) {
                            this.getTabsFromAPI()
                        } else {
                            this.$toast.error(resp.data.message);
                        }
                        
                    });                    
                }
            },

            changeOrder(tabs) {
                this.API({type:'post', url:"/engine/module/"+this.module.id+"/tabulation/modify", params :{tab:tabs,type:'order'}}).then((resp) => {
                        if(resp.data.success) {
                            this.$toast.success(resp.data.message);
                            this.getTabsFromAPI()
                        }
                        
                    });                
            }

        },
    
        mounted() { 
            if(this.module.id) this.getTabsFromAPI()
            
        }

    }

</script>

<style scoped>
.tabs-admin__swatch {
    width: 18px;
    height: 18px;
    margin-right: 7px;
    border: 1px solid rgba(0, 0, 0, .18);
    border-radius: 4px;
}
.tabs-admin__swatch--theme {
    background: linear-gradient(135deg, var(--app-tabs, #fff) 50%, var(--app-tabs-active, #3f51b5) 50%);
}
</style>

